import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useMixPanel } from '../../../../../components/MixPanel/useMixPanel';
import { RootState } from '../../../../../store/store';

export const NoDataEngagements: React.FC = (): JSX.Element => {
  const { dealsNoData } = useSelector((state: RootState) => state.deals);

  const { trackEvent } = useMixPanel();

  useEffect(() => {
    if (dealsNoData) {
      trackEvent('no-data-engagements');
    } // eslint-disable-next-line
  }, [dealsNoData]);

  const attrs = {
    wrapper: {
      className: 'engs-no-data',
    },

    title: {
      className: 'engs-no-data-title',
    },

    subTitle: {
      className: 'engs-no-data-subtitle',
    },

    stepOne: {
      className: 'engs-no-data-first-step',
    },

    stepTwo: {
      className: 'engs-no-data-second-step',
    },

    footer: {
      className: 'engs-no-data-footer',
    },
  };

  const subtitleText = `Follow the steps below to add your first engagement.\n
  It's an easy way to see all your interactions with a prospect in a single place.`;

  const footerText = `Q results will show both in your inbox 
  and in here after you refresh the page.`;

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.title}>My Engagements</div>
      <div {...attrs.subTitle}>{subtitleText}</div>
      <div {...attrs.stepOne} />
      <div {...attrs.stepTwo} />
      <div {...attrs.footer}>{footerText}</div>
    </div>
  );
};
